module.exports = __webpack_public_path__ + "shell/assets/images/providers/otccce.svg";